import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material';

@Component({
  selector: 'snackbar-success',
  templateUrl: 'snackbar-success.component.html',
  styles: [`
    .sequence-success {
      color: #5cbb47;
    }

    .sequence-success svg {
      position: relative;
      top: 2px;
      fill: #5cbb47;
      margin-right: 2px;
    }
  `],
})

export class SuccessSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {}
}


// WEBPACK FOOTER //
// ./src/app/shared/snackbars/snackbar-success/snackbar-success.component.ts